import {
  REJECTED_FROM_CITIZEN,
  TEMPORARILY_SAVED,
} from "../../../../constants";

const validateDocuments = (documents, docsPerKindFiltered, parentStatus) => {
  if (
    parentStatus === TEMPORARILY_SAVED ||
    parentStatus === REJECTED_FROM_CITIZEN
  ) {
    return true;
  } else {
    const requiredDocumentsIds = docsPerKindFiltered
      ?.filter((doc) => doc.req_flg)
      ?.map((doc) => doc.id);

    const uploadedDocumentsIds = documents?.map(
      (uploadedDoc) => uploadedDoc?.id
    );
    const isEveryRequiredDocumentUploaded = requiredDocumentsIds?.every(
      (requiredDocId) => uploadedDocumentsIds?.includes(requiredDocId)
    );

    return isEveryRequiredDocumentUploaded;
  }
};

export default validateDocuments;
